import { render, staticRenderFns } from "./ManageExternalStoreSync.vue?vue&type=template&id=4804f386&scoped=true"
import script from "./ManageExternalStoreSync.vue?vue&type=script&lang=js"
export * from "./ManageExternalStoreSync.vue?vue&type=script&lang=js"
import style0 from "./ManageExternalStoreSync.vue?vue&type=style&index=0&id=4804f386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4804f386",
  null
  
)

export default component.exports